export default __webpack_public_path__ + "static/media/bathroom1-before-480w.c612c2c5.png";